import React from "react";
import FileDownload from "js-file-download";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

//Fetch CalendarFilingAttachments
export const fetchCalendarFilingAttachments = async (fileTrackingID) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/Customer/ViewCustomerFilingTrackingAttachments/${fileTrackingID}`
    );

    // console.log("fetchCalendarFilingAttachments res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Download CalendarFilingAttachment
export const downloadCalendarFilingAttachment = async (
  attachmentId,
  fileTrackingId,
  customerId,
  fileName
) => {
  try {
    axios({
      url: `${API_BASE_URL}/Application/DownloadAttachment?AttachmentId=${attachmentId}&fileTrackingId=${fileTrackingId}&CustomerId=${customerId}`,
      method: "POST",
      responseType: "blob", // Important
    }).then((response) => {
      FileDownload(response.data, fileName);
    });
    return;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create CalendarFilingAttachment
export const createCalendarFilingAttachment = async (payload, customerId) => {
  try {
    const formData = new FormData();
    formData.append("Files", payload.Files);
    formData.append("fileTrackingId", payload.fileTrackingId);
    formData.append("createUser", payload.createUser);

    let url = `${API_BASE_URL}/Application/UpdateChildCustomerFilingTrackingAttachments?CustomerIds=${customerId}`;

    const res = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("createCalendarFilingAttachment res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete CalendarFilingAttachments
export const deleteCalendarFilingAttachment = async (
  attachmentId,
  customerId,
  fileTrackingId
) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/Application/DeleteAttachment?CustomerId=${customerId}&AttachmentId=${attachmentId}&fileTrackingId=${fileTrackingId}`
    );

    console.log("deleteCalendarFilingAttachment res", res);
    return res;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};
